import React, { useState, useEffect } from "react";
import "./InfoCardsSection.css";
import { ApiUrl, BaseUrl } from "../../../Admin/API/ApiUrl";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useQuery } from "@tanstack/react-query";

export default function InfoCardsSection() {
 

const fetchSectionImages = async (sectionType) => {
  const response = await fetch(`${ApiUrl}/journal-metrics/${sectionType}`);
  const data = await response.json();

  if (!response.ok) {
    throw new Error("Failed to fetch " + sectionType);
  }

  return data || [];
};
const fetchGeneralInfo = async () => {
  const response = await fetch(`${ApiUrl}/generalinfo`);

  if (!response.ok) {
    throw new Error("Failed to fetch general info");
  }

  const data = await response.json();
  return data?.[0] || {};
};

const { data: info = {} } = useQuery({
  queryKey: ["generalInfo"],
  queryFn: fetchGeneralInfo,
  staleTime: 10 * 60 * 1000,
});



const { data: impactImages = [] } = useQuery({
  queryKey: ["journal-metrics", "impact_factor"],
  queryFn: () => fetchSectionImages("impact_factor"),
  staleTime: 10 * 60 * 1000,
});

const { data: callForPapers = [] } = useQuery({
  queryKey: ["journal-metrics", "call_for_papers"],
  queryFn: () => fetchSectionImages("call_for_papers"),
  staleTime: 10 * 60 * 1000,
});

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true
  };

  return (
    <section className="info-section" id="journal-information">
      <div className="info-background">
        <div className="info-overlay">
          <h2 className="info-heading">Journal Information</h2>

          <div className="info-container">
            <div className="info-card">
              <h3>General Information</h3>

              <p title={info.issn}>
                <strong>ISSN:</strong> <span className="truncate">{info.issn}</span>
              </p>

              <p title={info.frequency}>
                <strong>Frequency: </strong> <span className="truncate">{info.frequency}</span>
              </p>

              <p title={info.email || "ijacna@gmail.com"}>
                <strong>Email:</strong>{" "}
                <span className="truncate">
                  {info.email || "ijacna@gmail.com"}
                </span>
              </p>
            </div>

            <div className="info-card">
              <h3>Conference</h3>
              <p>Update Soon</p>
            </div>

            <div className="info-card">
              <h3>Call For Paper</h3>

              {callForPapers.length > 1 ? (
                <Slider {...sliderSettings} className="info-slider">
                  {callForPapers.map((img, index) => (
                    <div key={index} className="info-image-wrapper">
                      <img
                        src={`${BaseUrl}/${img.image_path}`}
                        alt="Impact Factor"
                        className="info-card-image"
                        loading="lazy"
                      />
                    </div>
                  ))}
                </Slider>
              ) : callForPapers.length === 1 ? (
                <img
                  src={`${BaseUrl}/${callForPapers[0].image_path}`}
                  alt="Impact Factor"
                  className="info-card-image"
                  loading="lazy"

                />
              ) : (
                <p>Update Soon</p>
              )}
            </div>

            <div className="info-card">
              <h3>Impact Factor</h3>

              {impactImages.length > 1 ? (
                <Slider {...sliderSettings} className="info-slider">
                  {impactImages.map((img, index) => (
                    <div key={index} className="info-image-wrapper">
                      <img
                        src={`${BaseUrl}/${img.image_path}`}
                        alt="Impact Factor"
                        className="info-card-image"
                        loading="lazy"

                      />
                    </div>
                  ))}
                </Slider>
              ) : impactImages.length === 1 ? (
                <img
                  src={`${BaseUrl}/${impactImages[0].image_path}`}
                  alt="Impact Factor"
                  className="info-card-image"
                  loading="lazy"
                />
              ) : (
                <p>Update Soon</p>
              )}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
